import { UseMutateAsyncFunction, useMutation } from 'react-query';

import {
  UserCreateWithPhoneRequestType,
  UserCreateWithPhoneResponseType
} from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useGetSignUpWithPhoneOTP(): {
  getSignUpWithPhoneOTPAPI: UseMutateAsyncFunction<
    UserCreateWithPhoneResponseType,
    unknown,
    {
      phoneNumber: string;
      countryCode: string;
      clientId?: string;
    },
    unknown
  >;
  error;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getSignUpWithPhoneOTP = (params) => {
    const { phoneNumber, countryCode, clientId } = params;
    const request: UserCreateWithPhoneRequestType = {
      phone_number: phoneNumber,
      country_code: countryCode
    };

    if (clientId) {
      request.client_id = clientId;
    }
    return ibUserAccountsAPIService.userCreateWithPhoneNumber(request);
  };

  const { mutateAsync, error, status } = useMutation(getSignUpWithPhoneOTP, {
    mutationKey: ['getSignUpWithPhoneOTPAPI']
  });

  return {
    getSignUpWithPhoneOTPAPI: mutateAsync,
    error,
    status
  };
}

export { useGetSignUpWithPhoneOTP };
